import './copy_to_clipboard_button.less';

import autobind from 'class-autobind';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { SafeTipsy } from 'zoomforth_component_lib/tipsy.jsx';
import Button from 'zoomforth_component_lib/btn_basic.jsx';
import Clipboard from 'clipboard';


class CopyToClipboardButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isCopied: false,
      hasError: false
    };

    this.clipboard = null;
    this.copyBtnRef = null;
    this.displayTimeoutId = null;

    autobind(this);
  }

  componentWillUnmount() {
    if (this.displayTimeoutId) {
      clearTimeout(this.displayTimeoutId);
    }

    this.clipboard && this.clipboard.destroy();
  }

  render() {
    let tipContent = '';

    const {
      isCopied,
      hasError
    } = this.state;

    const {
      type,
      children,
      className,
      style,
      data,
      successContent,
      failureContent,
      helpContent,
      helpClassName,
      helpMouseEnterDelay,
      helpMouseLeaveDelay,
      helpPlacement,
      ...btnProps
    } = this.props;

    if (isCopied) {
      tipContent = successContent;
    } else if (hasError) {
      tipContent = failureContent;
    }

    return (
      <SafeTipsy 
        // The "help" tooltip explaining what this thing is
        // should function like a normal tooltip
        content={helpContent}
        className={helpClassName}
        mouseEnterDelay={helpMouseEnterDelay}
        mouseLeaveDelay={helpMouseLeaveDelay}
        placement={helpPlacement}
        {...(isCopied ? { visible: false } : {})}
      >
        <SafeTipsy
          // The "success/failure" tooltip explaining what happened
          // should be visible immediately and disappear after n secs
          content={tipContent}
          placement={helpPlacement}
          visible={!!tipContent}
        >

          <Button
            {...btnProps}
            type={type}
            tellRef={(ref)=> {
              this.copyBtnRef = ref; 
            }}
            className={classNames('copy-to-clipboard', className)}
            style={style}
            data-clipboard-text={data}
            onClick={this.handleClick}
          >
            { children }
          </Button>
        </SafeTipsy>
      </SafeTipsy>
    );
  }

  handleClick(evt) {
    evt.stopPropagation();

    this.setState({ isCopied: false });

    if (!this.clipboard) {
      this.clipboard = new Clipboard(this.copyBtnRef, {});

      this.clipboard.on('success', (e)=> {
        e.clearSelection();
        this.handleSuccess();
      });

      this.clipboard.on('error', this.handleFailure());

      this.clipboard.onClick(evt);
    }
  }

  handleSuccess() {
    this.setState({
      isCopied: true,
      hasError: false
    });

    this.displayTimeoutId = setTimeout(() => {
      this.setState({ isCopied: false });
    }, 2000);

    if (this.props.onSuccess) {
      this.props.onSuccess();
    }
  }

  handleFailure() {
    this.setState({
      isCopied: false,
      hasError: true
    });

    if (this.props.onFailure) {
      this.props.onFailure();
    }
  }

}


CopyToClipboardButton.propTypes = {
  type: PropTypes.string,
  // data is the content to copy to the clipboard
  data: PropTypes.string,
  // helpContent is the initial Tipsy hover state
  helpContent: PropTypes.node,
  // successContent is the Tipsy content if successfully copied
  successContent: PropTypes.node,
  // failureContent is the Tipsy content if copying is not supported
  failureContent: PropTypes.node,
  // onSuccess is run if a successful copy is made
  onSuccess: PropTypes.func,
  // onFailure is run if an error occurs while copying
  onFailure: PropTypes.func
};

CopyToClipboardButton.defaultProps = {
  data: '',
  helpContent: 'Click to copy to clipboard',
  successContent: 'Copied to clipboard!',
  failureContent: 'Your Browser Does Not Support Copying To Clipboard',
  className: ''
};

export default CopyToClipboardButton;
